export default "__VITE_ASSET__CHTOtb8p__"